export type ScaffoldingStepFields = {
  squareMeters: number;
  accessRoutes: number;
  scaffoldingType: string;
  scaffoldingIntendedFor: string;
  scaffoldingWidth: string;
  scaffoldingHeight: string;
};

export type ScaffoldingStepErrors = Record<keyof ScaffoldingStepFields, string>;

export const validateScaffoldingStep = (fields: ScaffoldingStepFields): ScaffoldingStepErrors => ({
  squareMeters: fields.squareMeters > 0 ? '' : 'Ange antal kvadratmeter',
  accessRoutes: fields.accessRoutes > 0 ? '' : 'Ange antal tillträdesleder',
  scaffoldingType: fields.scaffoldingType.trim() ? '' : 'Ange typ av ställning',
  scaffoldingIntendedFor: fields.scaffoldingIntendedFor.trim() ? '' : 'Ange vad ställningen är avsedd för',
  scaffoldingWidth: fields.scaffoldingWidth.trim() ? '' : 'Ange ställningsbredd',
  scaffoldingHeight: fields.scaffoldingHeight.trim() ? '' : 'Ange höjd',
});

export const scaffoldingStepHasErrors = (errors: ScaffoldingStepErrors): boolean =>
  Object.values(errors).some((error) => error.length > 0);

export const emptyScaffoldingStepErrors = (): ScaffoldingStepErrors => ({
  squareMeters: '',
  accessRoutes: '',
  scaffoldingType: '',
  scaffoldingIntendedFor: '',
  scaffoldingWidth: '',
  scaffoldingHeight: '',
});
